import { render, staticRenderFns } from "./ghTable.vue?vue&type=template&id=89b9c2c6&scoped=true&"
import script from "./ghTable.vue?vue&type=script&lang=js&"
export * from "./ghTable.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=89b9c2c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b9c2c6",
  null
  
)

export default component.exports